import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@telus-uds/components-web';
import ErrorIcon from '../../assets/images/icon_error_messages.gif';

const ErrorMessage = ({ isError, message }) => {
  return (
    <div id="error-message-content" style={{ display: 'block' }}>
      <div id="error-message-icon">
        <img src={ErrorIcon} alt="error_icon" />
      </div>
      <div id="error-message-title">
        <Typography>
          {message}
        </Typography>
      </div>
      <div className="clear" />
      <div id="error-message-message">
        <Typography>
          {isError}
          <br />
        </Typography>
      </div>
    </div>
  );
};

ErrorMessage.propTypes = {
  isError: PropTypes.bool.isRequired,
  message: PropTypes.string.isRequired,
};
export default ErrorMessage;
